// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---dev-kit-gatsby-theme-console-doc-src-runtime-site-layout-page-element-tsx": () => import("./../../dev-kit/gatsby-theme-console-doc/src/runtime/SiteLayout/PageElement.tsx" /* webpackChunkName: "component---dev-kit-gatsby-theme-console-doc-src-runtime-site-layout-page-element-tsx" */)
}

